import React, { useRef, useEffect, useState } from 'react';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const ControlMetric = ({ height, data }) => {
  const safeHeight = height && height > 100 ? height : 300;

  // const data = [
  //   { type: 'Preventive', count: 12 },
  //   { type: 'Detective', count: 7 },
  //   { type: 'Corrective', count: 4 },
  // ];
  const [processedData, setprocessedData] = useState([]);
  const [totalControls, settotalControls] = useState(0);
  useEffect(() => {
    if (data) {
      setprocessedData(data)
      settotalControls(data.reduce((sum, item) => sum + item.count, 0))
    }
  }, [data]);

  return (
    <div
      className="w-full bg-white rounded-lg flex flex-col justify-center"
      style={{ 
        height: typeof height === 'string' ? height : `${safeHeight}px`,
        minHeight: '100px',
        maxHeight: '150px',
        padding: 'min(12px, 2vh) min(12px, 2vw)'
      }}
    >
      <div 
        className="text-gray-800 mb-1"
        style={{ 
          fontSize: 'min(14px, 3.5vw)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {totalControls} Controls
      </div>

      <div className="flex-1 flex items-center justify-center" style={{ minHeight: '60px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={processedData}
            margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="type" tick={{ fontSize: 'min(10px, 2.5vw)' }} />
            <Tooltip />
            <Bar dataKey="count" fill="#FED4AE" radius={[4, 4, 0, 0]}>
              <LabelList dataKey="count" position="center" fill="#0A4E62" style={{ fontSize: 'min(10px, 2.5vw)' }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("Controls", state.dashboard.general_dashboard_data.type_controls)
    return {

        //token: state.auth.token,
        //departments: state.department.departments,
        //department_id: state.department.department_id
        data:  state.dashboard.general_dashboard_data.type_controls
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ControlMetric);